import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Dizest } from "src/libs/portal/dizest/dizest";

@Component({
    selector: 'wiz-page-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-page {
  isolation: isolate;
}

.auth-page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(24, 24, 27, 0.055) 1px, transparent 1px), linear-gradient(90deg, rgba(24, 24, 27, 0.055) 1px, transparent 1px);
  background-size: 36px 36px;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent 72%);
}

.auth-page::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  height: 36%;
  pointer-events: none;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
}

.auth-visual {
  position: relative;
  overflow: hidden;
}

.auth-visual::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(255, 112, 67, 0.2), transparent 34%), linear-gradient(315deg, rgba(54, 199, 183, 0.16), transparent 38%);
}

.auth-visual::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 44px 44px;
  opacity: 0.62;
}

.auth-visual > * {
  position: relative;
  z-index: 1;
}

.auth-visual-map {
  position: relative;
  height: 300px;
  margin: 36px 0;
}

.auth-rail {
  position: absolute;
  right: 8%;
  left: 8%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.28), transparent);
}

.auth-rail-top {
  top: 24%;
  transform: rotate(-8deg);
}

.auth-rail-mid {
  top: 51%;
  transform: rotate(3deg);
}

.auth-rail-bottom {
  top: 75%;
  transform: rotate(-4deg);
}

.auth-node {
  position: absolute;
  width: 76px;
  height: 76px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(12px);
}

.auth-node::before,
.auth-node::after {
  content: "";
  position: absolute;
  left: 14px;
  right: 14px;
  height: 7px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.24);
}

.auth-node::before {
  top: 21px;
}

.auth-node::after {
  top: 36px;
  right: 27px;
}

.auth-node-a {
  top: 16%;
  left: 6%;
}

.auth-node-b {
  top: 5%;
  right: 16%;
}

.auth-node-c {
  bottom: 18%;
  left: 28%;
}

.auth-node-d {
  right: 4%;
  bottom: 6%;
}

.auth-node-a::before {
  background: #ff7043;
}

.auth-node-b::before {
  background: #f8b84e;
}

.auth-node-c::before {
  background: #36c7b7;
}

@media (max-width: 1023px) {
  .auth-page::before {
    background-size: 30px 30px;
    opacity: 0.72;
  }
}`],
})
export class PagePageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {
        this.dizest = new Dizest(service);
    }

    public mode: string = 'password';

    public user: any = {
        id: '',
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        this.mode = WizRoute.segment.mode ? WizRoute.segment.mode : 'password';

        const urlParams = new URLSearchParams(window.location.search);
        let redirectParam = urlParams.get('redirect');
        if (!redirectParam) redirectParam = "/";
        this.redirectParam = redirectParam;
        await this.service.auth.allow(false, this.redirectParam);
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: "Confirm",
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.user));
        let { code, data } = await this.dizest.api.call("auth", "login", user)
        if (code == 200) {
            location.href = this.redirectParam;
            return;
        }
        await this.alert(data);
    }
}

export default PagePageAccessComponent;